import { MenuItem } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useEffect, useState } from 'react';
import * as uuid from 'uuid';
import { useStream } from '../../hooks/useStream';
import { RoleEnum, StageViewModeEnum } from '../../models/Index';
import StateService from '../../services/stateService/StateService';
import { useStyles } from './styles';
import { ChevronDown } from '@carbon/icons-react';

function RoleChange() {
    const classes = useStyles();
    const [currentRoles, setCurrentRoles] = useState([] as RoleEnum[]);
    const [stageViewMode, setStageViewMode] = useStream(StateService.stageViewMode$);

    useEffect(() => {
        const currentRoles$ = StateService.currentRoles$.subscribe((currentRoles) => {
            setCurrentRoles(currentRoles);
        });

        return () => {
            currentRoles$.unsubscribe();
        };
    }, []);

    function switchRole(event) {
        StateService.stageViewMode$.next(StageViewModeEnum.PUBLISHED);
        StateService.currentRoles$.next([event.target.value]);
    }

    return (
        <div className={classes.root}>
            <FormControl>
                <Select
                    data-testid="type"
                    value={currentRoles[0] || RoleEnum.VIEWER}
                    onChange={switchRole}
                    inputProps={{
                        name: 'type',
                        id: 'type',
                        style: { fontSize: '16px' },
                    }}
                    IconComponent={ChevronDown}
                    disabled={stageViewMode === StageViewModeEnum.WORK_IN_PROGRESS}
                >
                    <MenuItem className={classes.dropDownOption} key="1" value={RoleEnum.SUPER_USER}>
                        {RoleEnum.SUPER_USER}
                    </MenuItem>
                    <MenuItem className={classes.dropDownOption} key="2" value={RoleEnum.ADMIN}>
                        {RoleEnum.ADMIN}
                    </MenuItem>
                    <MenuItem className={classes.dropDownOption} key="3" value={RoleEnum.DESIGNER}>
                        {RoleEnum.DESIGNER}
                    </MenuItem>
                    <MenuItem className={classes.dropDownOption} key="4" value={RoleEnum.VIEWER}>
                        {RoleEnum.VIEWER}
                    </MenuItem>
                </Select>
            </FormControl>
        </div>
    );
}

export default RoleChange;
